import React, { useEffect, useState } from 'react';
import MasterLayout from '../../layouts/MasterLayout';
import ThemeBreadcrumb from '../../components/themes/ThemeBreadcrumb';
import AppNotification from '../../helpers/AppNotification';
import TransactionModel from '../../models/TransactionModel';
import Paginate from '../../components/paginate/Paginate';

function TransactionHistoryPage() {
    const [items, setItems] = useState([]);
    const [stats, setStats] = useState({
        total_create_bank: 0,
        create_bank_vip: 0,
        create_bank_money: 0,
        total_renew_bank: 0,
        user_renew: 0,
        admin_renew: 0,
        total_vip_actions: 0,
        total_edit_bank: 0,
        total_money_spent_fm: '0',
    });
    const [meta, setMeta] = useState({});
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(25);
    const [category, setCategory] = useState('ALL');
    const [quickRange, setQuickRange] = useState('ALL');

    const [keyword, setKeyword] = useState({
        start_date: '',
        end_date: '',
        name: '',
    });

    const [appliedSearch, setAppliedSearch] = useState({
        start_date: '',
        end_date: '',
        name: '',
    });

    const formatDateInput = (dateObj) => {
        const y = dateObj.getFullYear();
        const m = String(dateObj.getMonth() + 1).padStart(2, '0');
        const d = String(dateObj.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };

    const handleQuickDateRange = (rangeType) => {
        setQuickRange(rangeType);
        const now = new Date();
        let start = '';
        let end = '';

        if (rangeType === 'TODAY') {
            start = formatDateInput(now);
            end = formatDateInput(now);
        } else if (rangeType === 'YESTERDAY') {
            const yest = new Date(now);
            yest.setDate(now.getDate() - 1);
            start = formatDateInput(yest);
            end = formatDateInput(yest);
        } else if (rangeType === '7DAYS') {
            const sevenAgo = new Date(now);
            sevenAgo.setDate(now.getDate() - 6);
            start = formatDateInput(sevenAgo);
            end = formatDateInput(now);
        } else if (rangeType === 'THIS_MONTH') {
            const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
            start = formatDateInput(firstDay);
            end = formatDateInput(now);
        }

        const nextKeyword = {
            ...keyword,
            start_date: start,
            end_date: end,
        };
        setKeyword(nextKeyword);
        setAppliedSearch(nextKeyword);
        setPage(1);
    };

    const handleCategoryChange = (newCat) => {
        setCategory(newCat);
        setPage(1);
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'start_date' || name === 'end_date') {
            setQuickRange('CUSTOM');
        }
        setKeyword((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setPage(1);
        setAppliedSearch({ ...keyword });
    };

    const handleResetFilter = () => {
        const empty = { start_date: '', end_date: '', name: '' };
        setKeyword(empty);
        setAppliedSearch(empty);
        setCategory('ALL');
        setQuickRange('ALL');
        setPage(1);
    };

    const handleChangePerPage = (e) => {
        setPerPage(Number(e.target.value));
        setPage(1);
    };

    const changePage = (newPage) => {
        setPage(newPage);
    };

    const handleSetPage = (delta) => {
        setPage((prev) => Math.max(1, prev + delta));
    };

    useEffect(() => {
        setLoading(true);
        TransactionModel.historyAdmin({
            search: {
                ...appliedSearch,
                category: category,
            },
            page: page,
            perPage: perPage,
        })
            .then((res) => {
                setItems(res.data || []);
                if (res.stats) {
                    setStats(res.stats);
                }
                setMeta(res.meta || {});
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
                AppNotification.showError('Không thể tải dữ liệu thống kê!');
            });
    }, [page, perPage, category, appliedSearch]);

    const getBadgeClass = (type) => {
        switch (type) {
            case 'BUYACCOUNT':
                return 'badge-success';
            case 'RENEWACCOUNT':
                return 'badge-info';
            case 'ADMIN_RENEW':
                return 'badge-warning';
            case 'UPGRADEVIP':
            case 'MASSUPGRADEVIP':
            case 'BUY_COMBO':
            case 'ADMIN_ADD_VIP':
            case 'RECHARGE_VIP_CODE':
                return 'badge-warning';
            case 'EDITACCOUTNAPP':
                return 'badge-primary';
            case 'RECHARGE':
            case 'RECHARGECODE':
            case 'ADMINDEPOSIT':
                return 'badge-success';
            default:
                return 'badge-secondary';
        }
    };

    return (
        <MasterLayout>
            <ThemeBreadcrumb title="Thống kê Tạo Bank & Gia Hạn" />

            {/* 4 Ô Thống Kê Tổng Quan */}
            <div className="row mb-3">
                <div className="col-xl-3 col-md-6 mb-3">
                    <div
                        className="card h-100 mb-0"
                        style={{
                            cursor: 'pointer',
                            background: category === 'CREATE_BANK' ? 'var(--wus-card-inner)' : undefined,
                            border: category === 'CREATE_BANK' ? '1px solid var(--wus-success)' : undefined,
                        }}
                        onClick={() => handleCategoryChange('CREATE_BANK')}
                    >
                        <div className="card-body py-3 px-3">
                            <div className="text-muted" style={{ fontSize: '11.5px', fontWeight: 500, fontFamily: 'var(--wus-mono)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                Lượt Tạo Bank Mới
                            </div>
                            <div className="mt-1 mb-1" style={{ fontSize: '26px', fontWeight: 500, fontFamily: 'var(--wus-display-font)', color: 'var(--wus-success-text)' }}>
                                {stats.total_create_bank} <span style={{ fontSize: '13px', fontWeight: 400, fontFamily: 'var(--wus-font)' }}>tài khoản</span>
                            </div>
                            <div className="text-muted" style={{ fontSize: '12px' }}>
                                Dùng VIP: <b>{stats.create_bank_vip}</b> | Dùng Tiền: <b>{stats.create_bank_money}</b>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-xl-3 col-md-6 mb-3">
                    <div
                        className="card h-100 mb-0"
                        style={{
                            cursor: 'pointer',
                            background: category === 'RENEW_BANK' ? 'var(--wus-card-inner)' : undefined,
                            border: category === 'RENEW_BANK' ? '1px solid var(--wus-info)' : undefined,
                        }}
                        onClick={() => handleCategoryChange('RENEW_BANK')}
                    >
                        <div className="card-body py-3 px-3">
                            <div className="text-muted" style={{ fontSize: '11.5px', fontWeight: 500, fontFamily: 'var(--wus-mono)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                Lượt Gia Hạn Bank
                            </div>
                            <div className="mt-1 mb-1" style={{ fontSize: '26px', fontWeight: 500, fontFamily: 'var(--wus-display-font)', color: 'var(--wus-info-text)' }}>
                                {stats.total_renew_bank} <span style={{ fontSize: '13px', fontWeight: 400, fontFamily: 'var(--wus-font)' }}>lượt</span>
                            </div>
                            <div className="text-muted" style={{ fontSize: '12px' }}>
                                User tự gia hạn: <b>{stats.user_renew}</b> | Admin gia hạn: <b>{stats.admin_renew}</b>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-xl-3 col-md-6 mb-3">
                    <div
                        className="card h-100 mb-0"
                        style={{
                            cursor: 'pointer',
                            background: category === 'VIP' ? 'var(--wus-card-inner)' : undefined,
                            border: category === 'VIP' ? '1px solid var(--wus-warning)' : undefined,
                        }}
                        onClick={() => handleCategoryChange('VIP')}
                    >
                        <div className="card-body py-3 px-3">
                            <div className="text-muted" style={{ fontSize: '11.5px', fontWeight: 500, fontFamily: 'var(--wus-mono)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                Nâng Cấp & Gói VIP
                            </div>
                            <div className="mt-1 mb-1" style={{ fontSize: '26px', fontWeight: 500, fontFamily: 'var(--wus-display-font)', color: 'var(--wus-warning-text)' }}>
                                {stats.total_vip_actions} <span style={{ fontSize: '13px', fontWeight: 400, fontFamily: 'var(--wus-font)' }}>giao dịch VIP</span>
                            </div>
                            <div className="text-muted" style={{ fontSize: '12px' }}>
                                Sửa STK Bank: <b>{stats.total_edit_bank}</b> lượt
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-xl-3 col-md-6 mb-3">
                    <div
                        className="card h-100 mb-0"
                        style={{
                            cursor: 'pointer',
                            background: 'var(--wus-card-inner)',
                        }}
                        onClick={() => handleCategoryChange('ALL')}
                    >
                        <div className="card-body py-3 px-3">
                            <div className="text-muted" style={{ fontSize: '11.5px', fontWeight: 500, fontFamily: 'var(--wus-mono)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                Tổng Tiền User Chi Tiêu (≤ 40 Ngày)
                            </div>
                            <div className="mt-1 mb-1" style={{ fontSize: '26px', fontWeight: 600, fontFamily: 'var(--wus-mono)' }}>
                                {stats.total_money_spent_fm || '0'} <span style={{ fontSize: '13px', fontWeight: 500 }}>VNĐ</span>
                            </div>
                            <div className="text-muted" style={{ fontSize: '12px' }}>
                                Tối đa 40 ngày đổ về (Tạo Bank, Gia hạn, Sửa STK)
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-2">
                            <h4 className="card-title mb-0">Danh sách hoạt động Tạo Bank & Gia Hạn</h4>

                            {/* Bộ chọn nhanh khoảng thời gian */}
                            <div className="d-flex flex-wrap gap-1">
                                <button
                                    type="button"
                                    className={`btn btn-sm ${quickRange === 'ALL' ? 'btn-primary' : 'btn-secondary'}`}
                                    onClick={() => handleQuickDateRange('ALL')}
                                >
                                    40 ngày qua
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-sm ${quickRange === 'TODAY' ? 'btn-primary' : 'btn-secondary'}`}
                                    onClick={() => handleQuickDateRange('TODAY')}
                                >
                                    Hôm nay
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-sm ${quickRange === 'YESTERDAY' ? 'btn-primary' : 'btn-secondary'}`}
                                    onClick={() => handleQuickDateRange('YESTERDAY')}
                                >
                                    Hôm qua
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-sm ${quickRange === '7DAYS' ? 'btn-primary' : 'btn-secondary'}`}
                                    onClick={() => handleQuickDateRange('7DAYS')}
                                >
                                    7 ngày qua
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-sm ${quickRange === 'THIS_MONTH' ? 'btn-primary' : 'btn-secondary'}`}
                                    onClick={() => handleQuickDateRange('THIS_MONTH')}
                                >
                                    Tháng này
                                </button>
                            </div>
                        </div>

                        <div className="card-body">
                            {/* Các Tab phân loại hoạt động */}
                            <div className="d-flex flex-wrap gap-2 mb-3 pb-3" style={{ borderBottom: '1px solid var(--wus-border)' }}>
                                <button
                                    type="button"
                                    className={`btn btn-sm ${category === 'ALL' ? 'btn-primary' : 'btn-secondary'}`}
                                    onClick={() => handleCategoryChange('ALL')}
                                >
                                    Tất cả hoạt động
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-sm ${category === 'CREATE_BANK' ? 'btn-primary' : 'btn-secondary'}`}
                                    onClick={() => handleCategoryChange('CREATE_BANK')}
                                >
                                    Tạo Bank mới ({stats.total_create_bank})
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-sm ${category === 'RENEW_BANK' ? 'btn-primary' : 'btn-secondary'}`}
                                    onClick={() => handleCategoryChange('RENEW_BANK')}
                                >
                                    Gia hạn Bank ({stats.total_renew_bank})
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-sm ${category === 'VIP' ? 'btn-primary' : 'btn-secondary'}`}
                                    onClick={() => handleCategoryChange('VIP')}
                                >
                                    Gói & Nâng cấp VIP ({stats.total_vip_actions})
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-sm ${category === 'EDIT_BANK' ? 'btn-primary' : 'btn-secondary'}`}
                                    onClick={() => handleCategoryChange('EDIT_BANK')}
                                >
                                    Sửa STK ({stats.total_edit_bank})
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-sm ${category === 'DEPOSIT' ? 'btn-primary' : 'btn-secondary'}`}
                                    onClick={() => handleCategoryChange('DEPOSIT')}
                                >
                                    Nạp tiền
                                </button>
                            </div>

                            {/* Thanh lọc tìm kiếm chi tiết */}
                            <form onSubmit={handleSubmit} className="mb-3">
                                <div className="row g-2 align-items-end">
                                    <div className="col-md-2 col-6">
                                        <label>Hiển thị</label>
                                        <select
                                            className="form-control"
                                            value={perPage}
                                            onChange={handleChangePerPage}
                                        >
                                            <option value={25}>25 dòng</option>
                                            <option value={50}>50 dòng</option>
                                            <option value={100}>100 dòng</option>
                                        </select>
                                    </div>
                                    <div className="col-md-3 col-12">
                                        <label>Tìm User / Số TK / Nội dung</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Nhập username, STK, tên chủ TK..."
                                            name="name"
                                            value={keyword.name}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <label>Từ ngày</label>
                                        <input
                                            type="date"
                                            name="start_date"
                                            className="form-control"
                                            value={keyword.start_date}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <label>Đến ngày</label>
                                        <input
                                            type="date"
                                            name="end_date"
                                            className="form-control"
                                            value={keyword.end_date}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-3 col-12 d-flex gap-2">
                                        <button className="btn btn-primary" type="submit">
                                            Lọc dữ liệu
                                        </button>
                                        <button
                                            className="btn btn-secondary"
                                            type="button"
                                            onClick={handleResetFilter}
                                        >
                                            Đặt lại
                                        </button>
                                    </div>
                                </div>
                            </form>

                            {/* Bảng danh sách */}
                            <div className="table-responsive">
                                <table className="table header-border table-responsive-sm">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '70px' }}>ID</th>
                                            <th style={{ width: '145px' }}>Thời gian</th>
                                            <th style={{ width: '170px' }}>Người dùng</th>
                                            <th style={{ width: '150px' }}>Loại thao tác</th>
                                            <th style={{ width: '210px' }}>Ngân hàng / STK</th>
                                            <th style={{ width: '125px' }}>Chi phí / Số tiền</th>
                                            <th>Chi tiết nội dung</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={7} className="text-center py-4">
                                                    Đang tải dữ liệu...
                                                </td>
                                            </tr>
                                        ) : items.length === 0 ? (
                                            <tr>
                                                <td colSpan={7} className="text-center py-4 text-muted">
                                                    Không có dữ liệu hoạt động nào trong khoảng lọc này.
                                                </td>
                                            </tr>
                                        ) : (
                                            items.map((item, key) => (
                                                <tr key={key}>
                                                    <td>#{item.id}</td>
                                                    <td style={{ whiteSpace: 'nowrap', fontSize: '12.5px' }}>
                                                        {item.create_at_fm}
                                                    </td>
                                                    <td>
                                                        <div style={{ fontWeight: 600, color: 'var(--wus-text)' }}>
                                                            {item.user_name}
                                                        </div>
                                                        {item.name_user && item.name_user !== item.user_name && (
                                                            <div className="text-muted" style={{ fontSize: '12px' }}>
                                                                {item.name_user}
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <span className={`badge ${getBadgeClass(item.type)}`}>
                                                            {item.type_label || item.type}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {item.resolved_bank_number ? (
                                                            <div>
                                                                <div>
                                                                    <span className="badge badge-primary me-1">
                                                                        {item.resolved_bank_name || 'BANK'}
                                                                    </span>
                                                                    <strong style={{ fontFamily: 'var(--wus-mono)' }}>
                                                                        {item.resolved_bank_number}
                                                                    </strong>
                                                                </div>
                                                                {item.resolved_bank_user && (
                                                                    <div className="text-muted" style={{ fontSize: '12px' }}>
                                                                        {item.resolved_bank_user}
                                                                    </div>
                                                                )}
                                                                {item.resolved_bank_expired && (
                                                                    <div style={{ fontSize: '11.5px', color: 'var(--wus-info-text)', fontWeight: 500 }}>
                                                                        Hạn: {item.resolved_bank_expired}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <span className="text-muted">---</span>
                                                        )}
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', fontWeight: 600 }}>
                                                        {Number(item.amount) > 0 ? (
                                                            <span>{item.amount_fm} đ</span>
                                                        ) : (
                                                            <span className="text-warning" style={{ fontSize: '12px' }}>
                                                                VIP / 0 đ
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td style={{ fontSize: '13px', lineHeight: 1.45 }}>
                                                        {item.note || '---'}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                                <Paginate
                                    meta={meta}
                                    changePage={changePage}
                                    page={page}
                                    handleSetPage={handleSetPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </MasterLayout>
    );
}

export default TransactionHistoryPage;
